import React from 'react';
import { Row, Col, Typography, Button, Space } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import cl from '../catalog.module.css';
import CardItem from '../CardItem';

const RightBlock = ({ category, isMobile, setIsShow, publication, active }) => {
    const navigate = useNavigate();
    return (
        <>
            {category && (
                <Col className={cl.cardRight}>
                    {!isMobile && (
                        <Row>
                            <Link
                                to={`/categories/${category.key}`}
                                onClick={() => setIsShow(false)}
                            >
                                <Typography className={cl.title}>
                                    {category.name}
                                </Typography>
                            </Link>
                        </Row>
                    )}
                    <Row style={{ gap: '80px', maxWidth: '100%' }}>
                        {/* <Row style={{ gap: '80px', maxWidth: '600px' }}> */}
                        {category.children &&
                            category.children.map((subcategory) => (
                                <Row
                                    className={cl.menuItemList}
                                    key={subcategory.id}
                                >
                                    <Link
                                        to={`/categories/${subcategory.key}`}
                                        className={cl.menuItemTitle}
                                        onClick={() => setIsShow(false)}
                                    >
                                        {subcategory.name}
                                    </Link>

                                    {subcategory.children &&
                                        subcategory.children.map((link) => (
                                            <Link
                                                key={link.key}
                                                to={`/categories/${link.key}`}
                                                className={cl.menuItem}
                                                onClick={() => setIsShow(false)}
                                            >
                                                {link.name}
                                            </Link>
                                        ))}
                                </Row>
                            ))}
                    </Row>
                </Col>
            )}
            {publication[active]?.data && (
                <div>
                    <div style={{ paddingLeft: '20px' }}>
                        <Typography.Title
                            level={5}
                            style={{ color: 'var(--white)' }}
                        >
                            {publication[active].title}
                        </Typography.Title>
                    </div>

                    <Row
                        justify={isMobile && 'center'}
                        style={{
                            padding: '20px',
                            gap: '10px',
                            flexWrap: 'wrap',
                        }}
                    >
                        {publication[active].data.map((item) => (
                            <CardItem
                                active={active}
                                item={item}
                                key={item.id}
                                close={setIsShow}
                            />
                        ))}
                    </Row>
                    <div style={{ paddingLeft: '20px' }}>
                        <Button
                            type="Link"
                            className={cl.menuItem}
                            onClick={() => {
                                navigate(`/publication/${active}`);
                                setIsShow(false);
                            }}
                        >
                            <Space>
                                {`Все ${publication[
                                    active
                                ]?.title?.toLowerCase()}`}
                                <ArrowRightOutlined />
                            </Space>
                        </Button>
                    </div>
                </div>
            )}
        </>
    );
};

export default RightBlock;
